export const ACTION = {

    LEARN_STNDOTP:'LEARN_STNDOTP',
    CLEAR_LEARN_STNDOTP: 'CLEAR_LEARN_STNDOTP',
    LEARN_VERIFYOTPDATA:'LEARN_VERIFYOTPDATA',
    CLEAR_LEARN_VERIFYOTPDATA: 'CLEAR_LEARN_VERIFYOTPDATA',
    TOOLS_CALLBACK:'TOOLS_CALLBACK',
    CLEAR_LEARN_TOOLS_CALLBACK: 'CLEAR_LEARN_TOOLS_CALLBACK',
    CALCULATE_TOPUP_SIP:'CALCULATE_TOPUP_SIP',
    CORNER_LEVELS:'CORNER_LEVELS',
    LEARN_SUBSCRIPTION:'LEARN_SUBSCRIPTION',
    CORNER_LEVELS_DATA:'CORNER_LEVELS_DATA',
    CORNER_SEARCH:'CORNER_SEARCH',
    SAVE_FEEDBACK:'SAVE_FEEDBACK',
    GET_EDU_COURSES_CONTENT: 'GET_EDU_COURSES_CONTENT',
    INVESTOR_AWARENESS: 'INVESTOR_AWARENESS',
    LEARN_INVESTOR_FAQS: 'LEARN_INVESTOR_FAQS',
    GET_STATE_DATA: 'GET_STATE_DATA',
    POST_SUBMIT_REGISTER_DATA: 'POST_SUBMIT_REGISTER_DATA',
    GET_IAP_DOWNLOADS: 'GET_IAP_DOWNLOADS',
    POST_IAP_DOWNLOAD_SEARCH: 'POST_IAP_DOWNLOAD_SEARCH',
    GET_KEY_INFORMATION: 'GET_KEY_INFORMATION',
    CORNER_SECTION_OVERVIEW: 'CORNER_SECTION_OVERVIEW',
    CORNER_LIST: 'CORNER_LIST',
    CORNER_VIDEO_SECTION: 'CORNER_VIDEO_SECTION',
    CORNER_PODCAST_SECTION: 'CORNER_PODCAST_SECTION',
    GET_CORNER_PODCAST_DETAILS: 'GET_CORNER_PODCAST_DETAILS',
    TOOLS_CALCULATE: 'TOOLS_CALCULATE',
    GET_IAP_MONTH_CORNER: 'GET_IAP_MONTH_CORNER',
    CLEAR_SAVE_FEEDBACK: 'CLEAR_SAVE_FEEDBACK',
    GET_CALCULATOR_METADATA:'GET_CALCULATOR_METADATA',
    GET_MFBYTES_METADATA :'GET_MFBYTES_METADATA',
    GET_BOOK_REVIEW_DATA:'GET_BOOK_REVIEW_DATA',
    BOOK_REVIEW_DETAILS:'BOOK_REVIEW_DETAILS',
    BOOK_REVIEW_COUNT:'BOOK_REVIEW_COUNT',
    GET_CORNER_VIDEO_DETAILS: 'GET_CORNER_VIDEO_DETAILS',
    POETRY_LOUNGE: 'POETRY_LOUNGE',
    THE_READING_ROOM: 'THE_READING_ROOM',
};

export const ENCRYPTION_CMS_KEY = {
    AES: 'aes-256-cbc', // AES Algorithm
    AES_IV: 'NT0F4aEzEFK2AP5xne5RWw==',
    AES_SECRET_KEY: 'MXz4kjjctNu0TSfG32oqAhDPJdLuwVvBdRnUALYvFnw=',
    INVALID_REQUEST: 'Invalid request',
};
